export default{
  getCookie (name) {
    if (document.cookie.length > 0) {
      let cstart = document.cookie.indexOf(name + '=')
      if (cstart !== -1) {
        cstart = cstart + name.length + 1
        let cend = document.cookie.indexOf('', cstart)
        if (cend === -1) {
          cend = document.cookie.length
        }
        return unescape(document.cookie.substring(cstart, cend))
      }
    }
    return ''
  },
  setCookie (name, value, minute) {
    let Minute = minute || 43200
    let exp = new Date()
    exp.setTime(exp.getTime() + Minute * 60 * 1000)
    document.cookie = name + '=' + escape(value) + 'expires=' + exp.toGMTString() + 'path=/'
  },
  delCookie (name) {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    let cval = this.getCookie(name)
    if (cval !== null) {
      document.cookie = name + '=' + cval + 'expires=' + exp.toGMTString() + 'path=/'
      document.cookie = name + '=' + cval + 'expires=' + exp.toGMTString() + 'path=/domain=.' + window.location.host + ''
    }
  },
  supportLS () {
    if (window.localStorage) {
      return true
    } else {
      return false
    }
  },
  setLS (key, value) {
    if (this.supportLS()) {
      this.removeLS(key)
      localStorage.setItem(key, value)
    } else {
      this.setCookie(key, value)
    }
  },
  getLS (key) {
    if (this.supportLS()) {
      return localStorage.getItem(key)
    } else {
      return this.getCookie(key)
    }
  },
  removeLS (key) {
    localStorage.removeItem(key)
  },
  clearLS () {
    localStorage.clear()
  }
}

export class Scroll {
  constructor (el, height, delay) {
    this.el = el
    this.el.innerHTML += this.el.innerHTML
    this.height = height
    this.maxHeight = this.el.scrollHeight / 2
    this.delay = delay * 1000
    this.counter = 0
    this.timer = null
    this.scroll()
  }
  scroll () {
    if (this.el.scrollTop < this.maxHeight) {
      this.el.scrollTop++
      this.counter++
    } else {
      this.counter = this.el.scrollTop = 0
    }
    if (this.counter < this.height) {
      this.timer = setTimeout(() => {
        this.scroll()
      }, 10)
    } else {
      this.counter = 0
      this.timer = setTimeout(() => {
        this.scroll()
      }, this.delay)
    }
  }
  stop () {
    clearTimeout(this.timer)
  }
  start () {
    this.timer = setTimeout(() => {
      this.scroll()
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js